export class FilterHolidays {
    description!: string;
}